export const CONTAINER_TYPE = {
    LOGIN: 'login',
    HR: 'HR',
    RECRUITER: 'recruiter',
    MANAGER: 'manageer',
    EMPLOYEE: 'employee',
    ADMIN: 'admin',
    WFM: 'wfm',
};
